// Footer.tsx - pied de page minimal : marque, liens légaux, gestion cookies.
import type { MouseEvent, ReactElement } from "react";
import { Icon } from "@hop-resto/ui";
import type { Path } from "../lib/router";
import { CONTACT_MAILTO } from "../lib/constants";

interface FooterProps {
  navigate: (to: Path) => void;
  /** Rouvre le bandeau de consentement cookies. */
  onManageCookies: () => void;
}

export function Footer({ navigate, onManageCookies }: FooterProps): ReactElement {
  const link = (to: Path) => (e: MouseEvent) => {
    e.preventDefault();
    navigate(to);
  };

  return (
    <footer className="footer container">
      <a href="/" onClick={link("/")} className="footer-brand" aria-label="Hop Resto - accueil">
        <img src="/hop-resto-logo-long.png" alt="Hop Resto" className="footer-logo" height={24} />
      </a>

      <nav className="footer-links" aria-label="Liens de bas de page">
        <a href="/mentions-legales" onClick={link("/mentions-legales")}>
          Mentions légales
        </a>
        <a href="/cgu" onClick={link("/cgu")}>
          CGU
        </a>
        <a href="/cgv" onClick={link("/cgv")}>
          CGV
        </a>
        <a href="/confidentialite" onClick={link("/confidentialite")}>
          Confidentialité
        </a>
        <button type="button" onClick={onManageCookies}>
          Gérer les cookies
        </button>
        <a href={CONTACT_MAILTO}>Contact</a>
      </nav>

      <span className="footer-pin">
        <Icon name="pin" size={13} stroke={2.4} color="var(--coral)" />
        Proudly developed in Compiègne
      </span>
    </footer>
  );
}
